import { cn } from '@/lib';
import React from 'react';

interface PageContentCardProps {
  children: React.ReactNode;
  className?: string;
}

export const PageContentCardFlex: React.FC<PageContentCardProps> = ({ children, className }) => {
  return (
    <section className={`px-5 space-y-5 bg-surface border border-border shadow-sm rounded-xl mx-auto py-5 text-onsurface flex flex-col justify-center items-center ${className}`}>
      {children}
    </section>
  );
};



export const PageContentCard: React.FC<PageContentCardProps> = ({ children, className }) => {


  return (
    <section className={cn(className, `space-y-2 bg-surface border border-border shadow-sm rounded-xl mx-auto text-onsurface py-4 px-4`)}>
      {children}
    </section>
  );
};


// CardHeader renders the shared section title.
export function ContentCardHeader({ text }: { text: string }) {
  return (
    <h2 className="text-onsurface text-lg font-semibold">
      {text}
    </h2>
  );
}


export const PageContentCardWithHeader: React.FC<PageContentCardProps & { header: string }> = ({ children, className, header }) => {
  return (
    <section className={cn(className, `space-y-2 bg-surface border border-border shadow-sm rounded-xl mx-auto text-onsurface py-4 px-4`)}>
      <ContentCardHeader text={header} />
      {children}
    </section>
  );
};

